module.exports = __webpack_public_path__ + "media/images/lb/025-e8759bcc8ed38c34d2978ce57edfad32.svg";